import React from "react";
import Taskbar from "./Taskbar";
import "./styles/App.css";

const App = () => {
  const folders = [
    { id: 1, name: "Game", icon: "./images/game.png" },
    { id: 2, name: "Folder", icon: "./images/folder 2.png" },
    {
      id: 3,
      name: "Internet Explorer",
      icon: "./images/internet explorer - main.png",
    },
    {
      id: 4,
      name: "My Computer",
      icon: "./images/my computer 2.png",
    },

    // Add more folders as needed
  ];

  return (
    <div>
      <Taskbar folders={folders} />
    </div>
  );
};

export default App;
